import { zodTransformFirestoreTimestampToDate } from "../utils/zodUtils.mjs";
import { zodFlavorId } from "./ids.mjs";
import { PiiCategory, meta } from "./meta.mjs";
import { z as z$1 } from "zod";

// src/models/recordingBookmark.ts
const recordingBookmarkClassTypeSchema = z$1.enum([
	"physical_fitness",
	"emotional_wellness",
	"mind_body_practice",
	"other"
]);
const customerRecordingBookmarkSchema = z$1.object({
	id: zodFlavorId(),
	customerId: zodFlavorId(),
	classInstanceId: zodFlavorId(),
	classId: zodFlavorId(),
	recordingId: zodFlavorId(),
	className: z$1.string(),
	instructorName: meta(z$1.string(), { pii: { category: "name" } }),
	classType: recordingBookmarkClassTypeSchema,
	classStartTimeUtc: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date()),
	createdAt: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date()),
	updatedAt: z$1.any().transform(zodTransformFirestoreTimestampToDate).pipe(z$1.date())
}).refine((data) => data.id === data.classInstanceId, {
	message: "Document ID and classInstanceId must match",
	path: ["id", "classInstanceId"]
});

export { customerRecordingBookmarkSchema, recordingBookmarkClassTypeSchema };
//# sourceMappingURL=recordingBookmark.mjs.map